import type { GetTrackingDetails } from "@freightsimple/generated-dashboard-openapi-client/models/GetTrackingDetails";
import { TrackingShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/TrackingShipmentState";

type TrackingNextStep =
  | { kind: "redirect"; state: TrackingShipmentState; id: string }
  | { kind: "showPublicTracking" }
  | { kind: "notFound" };

/**
 * Decides what the tracking screen does after it has the shipment's details and
 * has (if needed) attempted to switch the user into the shipment's linked company.
 *
 * A failed switch means the user can't reach the authenticated view for this
 * linked-company shipment (e.g. they don't have the switch permission), so we
 * show the public tracking view rather than redirecting them into a page that
 * would just 404.
 */
export function trackingResolveNextStep(
  details: GetTrackingDetails,
  switchFailed: boolean,
): TrackingNextStep {
  if (switchFailed) {
    return { kind: "showPublicTracking" };
  }

  if (details.id) {
    return { kind: "redirect", state: details.state, id: details.id };
  }

  // Unauthenticated users can't access a draft, so treat it as not found.
  if (details.state === TrackingShipmentState.Draft) {
    return { kind: "notFound" };
  }

  return { kind: "showPublicTracking" };
}
